import { useCallback, useRef, useState } from "react";
import { deleteFetch, uploadFetch, useFetch } from "../../hooks/useFetch";
import { IOfferPositionCheckListItemDocument, IProjectDocument } from "../../interfaces/IProjectDocument";
import { IProject } from "../../interfaces/IProject";
import {
    Card,
    CardContent,
    CircularProgress,
    Grid,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import { UploadFile } from "@mui/icons-material";
import { IMIMEType } from "../../interfaces/IMIMEType";
import { DocumentRow } from "./DocumentRow";
import { useDropzone } from "react-dropzone";
import { OfferPositionCheckListItemDocumentRow } from "../checkList/OfferPositionCheckListItemDocumentRow";
import { IOfferPositionCheckListItem } from "../../interfaces/IOfferPositionCheckListItem";

interface IProps {
    projectObject: IProject;
    setProjectObject: Function;
    isWorking: boolean;
    setIsWorking: Function;
}

export const DocumentTable: React.FC<IProps> = ({ projectObject, setProjectObject, isWorking, setIsWorking }) => {
    console.log(projectObject);
    const inputUpload = useRef<HTMLInputElement | null>(null);
    const [mimeTypeArray] = useFetch<IMIMEType[]>("/document/mimetype/");
    const [isUploading, setIsUploading] = useState(false);
    const [isUploading2, setIsUploading2] = useState(false);
    const [loadingText, setLoadingText] = useState("");

    const getAllCheckListItems = () => {
        const checklistItems: IOfferPositionCheckListItem[] = [];

        projectObject.Offers?.forEach((offer) => {
            offer.OfferPositions?.forEach((position) => {
                position.checkListItems?.forEach((item) => {
                    checklistItems.push(item);
                });
            });
        });

        return checklistItems;
    };

    const checkListItems = getAllCheckListItems();
    console.log(checkListItems);

    const handleUpdate = useCallback(
        async (document: IProjectDocument, name: string) => {
            let newDocument = { ...document.Document };
            delete newDocument.data;
            newDocument.file_name = name;

            setLoadingText("Dokument wird aktualisiert...");
            setIsUploading(true);

            const updatePromise = new Promise((resolve, reject) => {
                if (document.id === null) {
                    reject(new Error("Document ID is null"));
                    return;
                }
                uploadFetch(
                    `/project/document/${document.id}`,
                    false,
                    { Document: newDocument, Project: projectObject.id, User: 1 },
                    (projectDocument: IProjectDocument) => {
                        if (projectDocument) {
                            resolve(projectDocument);
                        } else {
                            reject(new Error("Upload failed"));
                        }
                    },
                );
            });
            try {
                const result = await updatePromise;
                if (!result) {
                    return;
                }

                let newDocument = { ...document.Document };
                newDocument.file_name = name;
                let newProjectObject = { ...projectObject };
                newProjectObject.Documents = newProjectObject.Documents.map((x) => {
                    if (x.id === document.id) {
                        x.Document.file_name = name;
                    }
                    return x;
                });
                setProjectObject(newProjectObject);
            } catch (error) {
                return;
            } finally {
                setIsUploading(false);
            }
        },
        [projectObject],
    );
    const handleFilesUpload = useCallback(
        async (acceptedFiles: File[]) => {
            if (acceptedFiles.length === 0 || mimeTypeArray === undefined) return;

            setLoadingText("Dokument wird hochgeladen...");
            setIsUploading(true);

            const uploadPromises = acceptedFiles.map((file) => {
                return new Promise<IProjectDocument>(async (resolve, reject) => {
                    const mimeType = mimeTypeArray.find((y) => y.MIMEtype === file.type);
                    if (!mimeType) {
                        reject(new Error("MIME type not supported"));
                        return;
                    }

                    const data = await fileToBase64(file);
                    const document = {
                        id: null,
                        file_name: file.name,
                        MIMEtype: mimeType,
                        data,
                    };

                    uploadFetch(
                        "/project/document/",
                        true,
                        { Document: document, Project: projectObject.id, User: 1 },
                        (projectDocument: IProjectDocument) => {
                            if (projectDocument) {
                                resolve(projectDocument);
                            } else {
                                reject(new Error("Upload failed"));
                            }
                        },
                    );
                });
            });

            try {
                const results = await Promise.all(uploadPromises);

                let newProjectObject = { ...projectObject };
                newProjectObject.Documents = [...projectObject.Documents, ...results];
                setProjectObject(newProjectObject);
            } catch (error) {
                console.error("Upload error:", error);
            } finally {
                setIsUploading(false);
            }
        },
        [mimeTypeArray, projectObject],
    );
    const handleDeleteCheckListDocs = useCallback(
        async (document: IProjectDocument) => {
            console.log(document);
            setLoadingText("Dokument wird gelöscht...");
            setIsUploading(true);

            const deletePromise = new Promise((resolve, reject) => {
                if (document.id === null) {
                    reject(new Error("Document ID is null"));
                    return;
                }
                deleteFetch(`/project/document/`, document.id, (deleted: boolean) => {
                    if (deleted) {
                        resolve(true);
                    } else {
                        reject(new Error("Delete failed"));
                    }
                });
            });

            try {
                const result = await deletePromise;
                if (!result) {
                    return;
                }

                let newProjectObject = { ...projectObject };
                newProjectObject.Documents = newProjectObject.Documents.filter((x) => x.id !== document.id);
                setProjectObject(newProjectObject);
            } catch (error) {
                return;
            } finally {
                setIsUploading(false);
            }
        },
        [projectObject],
    );
    const handleDelete = useCallback(
        async (doc: IOfferPositionCheckListItemDocument) => {
            setLoadingText("Dokument wird gelöscht...");
            setIsUploading2(true);

            const deletePromise = new Promise((resolve, reject) => {
                if (doc.id === null) {
                    reject(new Error("Document ID is null"));
                    return;
                }
                deleteFetch(`/offerpositionchecklistitem/document/`, doc.id, (deleted: boolean) => {
                    if (deleted) {
                        resolve(true);
                    } else {
                        reject(new Error("Delete failed"));
                    }
                });
            });

            try {
                const result = await deletePromise;
                if (!result) {
                    return;
                }

                let newProjectObject = {
                    ...projectObject,
                };

                newProjectObject.Offers?.forEach((offer) => {
                    offer.OfferPositions?.forEach((position) => {
                        position.checkListItems?.forEach((item) => {
                            item.document_objects = item.document_objects?.filter((document) => document.id !== doc.id);
                        });
                    });
                });

                setProjectObject(newProjectObject);
            } catch (error) {
                return;
            } finally {
                setIsUploading2(false);
            }
        },
        [projectObject],
    );

    const onDrop = useCallback(
        (acceptedFiles: File[]) => {
            handleFilesUpload(acceptedFiles);
        },
        [projectObject.Documents],
    );
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        noClick: true,
    });

    if (mimeTypeArray === undefined) {
        return <CircularProgress />;
    }

    async function fileToBase64(file: File) {
        let result_base64 = await new Promise((resolve) => {
            let fileReader = new FileReader();
            fileReader.onload = (e) => resolve(fileReader.result);
            fileReader.readAsDataURL(file);
        });
        return String(result_base64).split(",")[1];
    }
    const handleNormalUpload = (files: null | FileList) => {
        if (files !== null) {
            let acceptedFiles: File[] = Array.from(files);
            handleFilesUpload(acceptedFiles);
        }
    };
    const dropZoneTSX = () => {
        return (
            <div>
                <input
                    {...getInputProps()}
                    accept={String(mimeTypeArray.map((mimeType) => mimeType.MIMEtype).join(", "))}
                />
                <Card>
                    <CardContent>
                        <Typography variant="body2">Dokument(e) hier reinziehen</Typography>
                        Erlaubte Datentypen
                        <br />
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Datentyp</TableCell>
                                    <TableCell>Datenendung</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {mimeTypeArray?.map((mimeType) => (
                                    <TableRow>
                                        <TableCell>{mimeType?.MIMEtype}</TableCell>
                                        <TableCell>{mimeType.file_ending}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </CardContent>
                </Card>
            </div>
        );
    };

    return (
        <>
            <Typography variant={"h5"}>Dokumente</Typography>
            <div {...getRootProps()}>
                <input
                    hidden
                    ref={inputUpload}
                    type="file"
                    accept={String(mimeTypeArray.map((mimeType) => mimeType.MIMEtype).join(", "))}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleNormalUpload(event.target.files)}
                />

                <Typography variant={"h5"} sx={{ mb: 2, mt: 0 }}>
                    <IconButton
                        disabled={isUploading}
                        title="Daten über Auswähl hochladen"
                        onClick={() => inputUpload && inputUpload.current?.click()}
                        sx={{ float: "right" }}
                    >
                        <UploadFile />
                    </IconButton>
                    <>
                        <Typography variant="caption">
                            (Hier können Sie Ihre Dokumente per <i>Drag & Drop</i> hochladen)
                        </Typography>
                    </>
                </Typography>

                {isDragActive && dropZoneTSX()}

                <>
                    {isUploading ? (
                        <>
                            <Grid container spacing={2}>
                                <Grid item xs={12} display={"flex"} alignContent={"center"} justifyContent={"center"}>
                                    <CircularProgress />
                                </Grid>
                                <Grid item xs={12} display={"flex"} alignContent={"center"} justifyContent={"center"}>
                                    <Typography>{loadingText}</Typography>
                                </Grid>
                            </Grid>
                        </>
                    ) : (
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell width={"20%"}>Nr.</TableCell>
                                    <TableCell width={"60%"}>Dateiname</TableCell>
                                    <TableCell width={"20%"}>Aktionen</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {projectObject.Documents.map((document: IProjectDocument) => {
                                    return (
                                        <DocumentRow
                                            key={document.id}
                                            currentDocument={document}
                                            handleDelete={handleDelete}
                                            handleUpdate={handleUpdate}
                                        />
                                    );
                                })}
                            </TableBody>
                        </Table>
                    )}
                </>
            </div>
            <Typography variant={"h5"} mt={6} mb={2}>
                Dokumente aus Checkliste
            </Typography>
            <>
                {isUploading2 ? (
                    <>
                        <Grid container spacing={2}>
                            <Grid item xs={12} display={"flex"} alignContent={"center"} justifyContent={"center"}>
                                <CircularProgress />
                            </Grid>
                            <Grid item xs={12} display={"flex"} alignContent={"center"} justifyContent={"center"}>
                                <Typography>{loadingText}</Typography>
                            </Grid>
                        </Grid>
                    </>
                ) : (
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell width={"15%"}>Nr.</TableCell>
                                <TableCell width={"40%"}>Dateiname</TableCell>
                                <TableCell width={"30%"}>Checklistenpunkt</TableCell>
                                <TableCell width={"15%"}>Aktionen</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {checkListItems.map((item) =>
                                item.document_objects?.map((document) => (
                                    <OfferPositionCheckListItemDocumentRow
                                        key={document.id}
                                        currentDocument={document}
                                        mimeTypeArray={mimeTypeArray}
                                        deleteCheckListItemDocument={handleDelete}
                                        documentTab={true}
                                        checkListItem={item}
                                    />
                                )),
                            )}
                        </TableBody>
                    </Table>
                )}
            </>
        </>
    );
};
